import { render, staticRenderFns } from "./LoadingScreen.vue?vue&type=template&id=45e673ca&scoped=true&"
import script from "./LoadingScreen.vue?vue&type=script&lang=js&"
export * from "./LoadingScreen.vue?vue&type=script&lang=js&"
import style0 from "./LoadingScreen.vue?vue&type=style&index=0&id=45e673ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e673ca",
  null
  
)

export default component.exports